export function getFrameworkId(): string {
  return 'bootstrap5';
}
export { default as Bootstrap5Renderer, default } from './Bootstrap5Renderer.js';
